export const CompanyList = [
    {
        prop: "id",
        label: "id",
        width: "150",
        format: "",
        order: false,
        isShow: false
    },
    {
        prop: "code",
        label: "公司编号",
        width: "150",
        format: "",
        order: true,
        isShow: true
    },
    {
        prop: "name",
        label: "公司名称",
        width: "150",
        format: "",
        order: true,
        isShow: true
    },
    {
        prop: "status",
        label: "公司状态",
        width: "150",
        format: "status",
        order: false,
        isShow: true
    },
    {
        prop: "isPlatform",
        label: "是否平台方",
        width: "150",
        format: "checkbox",
        order: false,
        isShow: true
    },
    {
        prop: "creationTime",
        label: "创建时间",
        width: "150",
        format: "datetime",
        order: true,
        isShow: true
    }
    // {
    //     prop: "creatorId",
    //     label: "创建人",
    //     width: "150",
    //     format: "",
    //     order: false,
    //     isShow: true
    // },
    // {
    //     prop: "lastModificationTime",
    //     label: "修改时间",
    //     width: "150",
    //     format: "datetime",
    //     order: true,
    //     isShow: true
    // },
    // {
    //     prop: "lastModifierId",
    //     label: "修改人",
    //     width: "150",
    //     format: "",
    //     order: false,
    //     isShow: true
    // }
]



